import api from "!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.105.4/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.105.4/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.105.4__lodash@4.17.21_vue-template-compiler@2.6.11_webpack@5.105.4/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.8_webpack@5.105.4/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.105.4__lodash@4.17.21_vue-template-compiler@2.6.11_webpack@5.105.4/node_modules/vue-loader/lib/index.js??vue-loader-options!./ForgotPassword.vue?vue&type=style&index=0&id=31a10f6c&prod&scoped=true&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};